<template lang="pug">
.middle-content-wrapper
  img.middle-title(
    :src="displayImgs.repurchaseGoodsTitleImg || 'https://m.hellobike.com/4a5460e0_Frame%201912055208%202.png'"
  )
  img.middle-content(
    :src="displayImgs.goodsImg")
  </template>

<script>
export default {
  name: 'NoSubsidyCardInfo',
  props: {
    displayImgs: {
      type: Object,
      default: () => ({
        goodsImg: '',
        repurchaseGoodsTitleImg: '',
      }),
    },
  },
};
</script>

  <style lang="less" scoped>
  img.middle-title {
    position: absolute;
    top: 0.2rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    height: 0.25rem;
  }

  .middle-content {
    display: block;
    width: 3.35rem;
    height: 2.41rem;
  }
  </style>
